import * as types from '../mutation-types'
import { getLocalState, hasLocalState, PIN_NAV_PANEL } from '../../utils/local-storage.js'

export const mutations = {
  [types.SET_SHRINK_HEADER] (state, shrink) {
    state.shrinkHeader = shrink
  },
  [types.SET_SHOW_NAV_PANEL] (state, show) {
    state.showNavPanel = show
  },
  [types.SET_PIN_NAV_PANEL] (state, pin) {
    state.pinNavPanel = pin
  },
  [types.SET_SHOW_FOOTER] (state, show) {
    state.showFooter = show
  },
  [types.SET_MENU_ITEMS] (state, { menuItems }) {
    state.menuItems = menuItems
  },
  [types.SET_NAV_TOGGLER_AS_NEEDED] (state, flag) {
    state.navTogglerAsNeeded = flag
  },
  [types.SET_HEADER_TITLE] (state, title) {
    state.headerTitle = title
  },
  [types.SET_WINDOW_SIZE] (state, params) {
    state.windowWidth = params.width
    state.windowHeight = params.height
  },
  [types.SET_WINDOW_SCROLL_POS] (state, params) {
    state.scrollTop = params.top
    state.scrollLeft = params.left
  },
  [types.SET_STATUS_MESSAGE] (state, message) {
    state.statusMessage = message
  },
  [types.SET_LICENSE_MESSAGE] (state, message) {
    state.licenseMessage = message
  },
  [types.SET_PATH] (state, params) {
    const uiPath = params.location
    const pos = uiPath.lastIndexOf('/client')
    state.serverBasePath = uiPath.substr(0, pos + 1)
  },
  [types.SET_CURRENT_NAV] (state, nav) {
    state.currentNav = nav
  },
  [types.ADD_DIALOG] (state, dialog) {
    state.dialogs.push(dialog)
  },
  [types.REMOVE_TOP_DIALOG] (state) {
    state.dialogs.pop()
  },
}

export default {
  state: {
    shrinkHeader: false,
    showNavPanel: false,
    pinNavPanel: hasLocalState(PIN_NAV_PANEL) ? getLocalState(PIN_NAV_PANEL) : false,
    showFooter: true,
    menuItems: [],
    navTogglerAsNeeded: false,
    headerTitle: '',
    windowWidth: 0,
    windowHeight: 0,
    scrollTop: 0,
    scrollLeft: 0,
    statusMessage: null,
    licenseMessage: null,
    serverBasePath: '',
    currentNav: '',
    dialogs: [],
  },
  mutations,
  actions: {
    setCurrentNav ({ commit }, params) {
      commit(types.SET_CURRENT_NAV, params.page)
    },
    setLicenseMessage ({ commit }, params) {
      commit(types.SET_LICENSE_MESSAGE, params.message)
    },
  },
  getters: {
    getWindow: () => window,
    getDocument: () => document,
  },
}
